import { createArray } from "@/utils";
import { faker } from "@faker-js/faker";
import { random } from "lodash";

export interface Federation {
  id: string;
  name: string;
  shortName?: string;
  organizationType?: string;
  organizationTypeValue?: number;
  nhoNumber: number;
  organizationNumber: number;
  federationParentNumber?: number;
  childFederations?: Array<Federation>;
}

const randomItem = (): Federation => ({
  id: faker.datatype.uuid.toString(),
  name: faker.random.word(),
  shortName: faker.random.word(),
  organizationType: faker.random.word(),
  organizationTypeValue: random(1, 10),
  nhoNumber: random(1000, 9999),
  organizationNumber: random(1000, 9999),
  federationParentNumber: random(1000, 9999),
});

const randomList = (max = 5): number[] =>
  createArray(random(1, max), randomItem);

const customFilter = (item: Federation, queryText: string): boolean => {
  if (
    typeof item === "undefined" ||
    typeof item.name === "undefined" ||
    typeof item.nhoNumber === "undefined" ||
    typeof queryText === "undefined"
  ) {
    return false;
  }

  const name = item.name.toLowerCase();
  const number = item.nhoNumber.toString().toLowerCase();
  const searchText = queryText.toLowerCase();

  return name.indexOf(searchText) > -1 || number.indexOf(searchText) > -1;
};

const getOrganizationNumberByMo = (
  associations: Federation[],
  nhoNumber: number
): number =>
  associations.find((org: Federation) => org.nhoNumber == nhoNumber)
    ?.organizationNumber ?? -1;

export const AssociationUtils = {
  randomItem,
  randomList,
  customFilter,
  getOrganizationNumberByMo,
};
